import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";

import { TermsComponent } from "./terms.component";
import { TermsLayoutComponent } from "./terms.layout";

export const routes: Routes = [
    {
        path: "",
        component: TermsLayoutComponent,

        children: [
            {
                path: "",
                component: TermsComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class TermsRoutingModule {}
